export default __webpack_public_path__ + "static/media/top-fii.3c20f5e4.svg";